import { ShoppingBag } from 'lucide-react';
import usePageTitle from '../../hooks/usePageTitle';

const DashboardPurchases = () => {
  usePageTitle('My Purchases');

  return (
  <div className="max-w-2xl">
    <p className="chapter-label mb-4">MY PURCHASES</p>
    <h1 className="display-heading text-4xl md:text-5xl text-white mb-6">
      Purchase <em>history.</em>
    </h1>
    <div className="cine-card p-12 text-center">
      <ShoppingBag className="w-10 h-10 text-zinc-700 mx-auto mb-4" />
      <p className="text-sm text-zinc-400">No purchases yet. When you buy a course, it will appear here.</p>
    </div>
  </div>
  );
};

export default DashboardPurchases;
